import {
  ReconciliationOutlined,
  FieldTimeOutlined,
  SwapOutlined,
  CaretDownOutlined,
  DashboardOutlined,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  DownOutlined,
  VerticalAlignBottomOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Space, Slider, Input, Tag, Dropdown, Tooltip as tooltip } from "antd";
import axios from "axios";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { get, post } from "../Libraries/Ajax/HttpService";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import download from "../assets/images/download.svg";
import * as htmlToImage from "dom-to-image-more";
// import dayjs from "dayjs";
import { makeDisabledDatePastNDays } from "../utils/dateLimits";

// import FileSaver from "file-saver";
// import { useCurrentPng } from "recharts-to-png";
// import { RangeStepInput } from 'react-range-step-input';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  LineChart,
  Legend,
  Tooltip,
  Line,
  Label,
  Bar,
  BarChart,
  ResponsiveContainer,
} from "recharts";
import { Spin } from "antd";
// import Example from "./multipleselectDropdown";
import { CSVLink } from "react-csv";
// import * as htmlToImage from 'html-to-image';

import { toast } from "react-toastify";
import back from "../assets/images/back.svg";
import { useDistrict } from "../utils/DistrictContext";
import ExampleWithDistrict from "./multipleselectDropdown";

function Waters() {
  const { RangePicker } = DatePicker;
  const dateFormat = "YYYY/MM/DD";
  const weekFormat = "MM/DD";
  const [show, setshow] = useState(false);
  const domEl = useRef(null);
  const [first, setfirst] = useState(false);
  const [toggle, setToggle] = useState(false);

  const [defaultOption, setDefaultOption] = useState("Past Month");
  const [defaultOptionss, setDefaultOptionss] = useState("Category");
  const [defaultCategory, setDefaultCategory] = useState("industrial");
  const { Option } = Select;
  const [parameterthree, setParameterthree] = useState(null);
  const [callData, setcallData] = useState([]);
  const [response, setResponse] = useState([]);
  const [color, setColor] = useState([]);
  const [merge, setMerge] = useState([null]);
  const [nerge, setNerge] = useState([null]);
  const [aggregateData, setAggregateData] = useState([null]);
  const [nerges, setNerges] = useState([null]);
  // const [getAreaPng, { ref: areaRef }] = useCurrentPng();
  const [mergenew, setMergenew] = useState([null]);
  const [test, setTest] = useState([]);
  const arryDatas = [];
  const arryDatass = [];
  const arryDatasstwo = [];
  const arryDatassnew = [];
  const [parameterone, setParameterone] = useState(null);
  const [parametertwo, setParametertwo] = useState(null);
  const [optionone, setOptionone] = useState(["Weekday"]);
  const [optiononenew, setOptiononenew] = useState(["Day"]);
  const [water, setWater] = useState(true);
  const [wateragg, setWateragg] = useState(false);
  const [myDatas, setmyDatas] = useState([
    { meter: "145330", code: "PD", name: "PHMSCM Holdi" },
    { meter: "47197,L", code: "PD", name: "PHMSCM Holdi" },
  ]);
  const [myData, setmyData] = useState(["145330", "47197,L"]);
  // "145330", "47197,L"   add('145330-', '145330', 'PD', 'PHMSCM Holdi', 'undefined', 'undefined');
  const [mySample, setmySample] = useState(["145330-", "47197-L"]);
  const [initialSample, setinitialSample] = useState(["145330-", "47197-L"]);
  // const [myDatas, setmyDatas] = useState([]);
  // const [myData, setmyData] = useState([]);
  // const [mySample, setmySample] = useState([]);
  // const [initialSample, setinitialSample] = useState([]);
  const [myAggregate, setmyAggregate] = useState([]);
  const [slvalue, setSlvalue] = useState(1);
  const [value, setvalue] = useState(1);
  const [slmax, setSlmax] = useState(4);
  const [count, setCount] = useState(0);
  const [messagecount, setMessagecount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [enter, setEnter] = useState(false);
  const [listOfUsers, setListofUsers] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const disabledDate = makeDisabledDatePastNDays(2);

  console.log("disabledDate::", disabledDate);

  const inputRef = useRef(null);
  const controller = new AbortController();
  const signal = controller.signal;
  const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
  // let history = useHistory();
  const navigate = useNavigate();
  const selectedDistrict = useDistrict();

  useEffect(() => {
    if (
      defaultOption === "Past Month" ||
      defaultOption === "Past 3 Months" ||
      defaultOption === "Past Year"
    ) {
      setOptiononenew("Week");
    }
  }, [defaultOption]);
  useEffect(() => {
    if (!selectedDistrict?.selectedDistrict) return;

    // 1. Force the correct interval/option for the initial load
    setOptiononenew("Week");
    setDefaultOption("Past Month");
    setSlvalue(1);

    // 2. Set the district-specific meter IDs
    switch (selectedDistrict.selectedDistrict) {
      case "FB151":
        setmyDatas([{ meter: "288433", code: "DKRP0", name: "429700" }]);
        setmyData(["288433"]);
        // Note the trailing hyphen as requested for the meterid param
        setmySample(["288433-"]);
        setinitialSample(["288433-"]);
        break;

      case "GPMD":
        setmyDatas([
          { meter: "145330", code: "PD", name: "PHMSCM Holdi" },
          // If you only want one meter initially, remove the second one here
        ]);
        setmyData(["145330"]);
        setmySample(["145330-"]);
        setinitialSample(["145330-"]);
        break;

      default:
        setmyDatas([]);
        setmyData([]);
        setmySample([]);
        setinitialSample([]);
    }
  }, [selectedDistrict]);
  // useEffect(() => {
  //   if (!selectedDistrict?.selectedDistrict) return;
  //   switch (selectedDistrict) {
  //     case "FB151":
  //       // example setup for another district
  //       setmyDatas([{ meter: "288433", code: "DKRP0", name: "429700" }]);
  //       setmyData(["288433"]);
  //       setmySample(["288433"]);
  //       setinitialSample(["288433"]);
  //       break;

  //     case "GPMD":
  //       // example setup for PD district
  //       setmyDatas([
  //         { meter: "145330", code: "PD", name: "PHMSCM Holdi" },
  //         { meter: "47197,L", code: "PD", name: "PHMSCM Holdi" },
  //       ]);
  //       setmyData(["145330", "47197,L"]);
  //       setmySample(["145330-", "47197-L"]);
  //       setinitialSample(["145330-", "47197-L"]);
  //       break;

  //     default:
  //       // fallback — clear or set default
  //       setmyDatas([]);
  //       setmyData([]);
  //       setmySample([]);
  //       setinitialSample([]);
  //   }
  // }, [selectedDistrict]);

  useEffect(() => {
    const isMizuWatch = window.location.href.includes("mizuwatch.com");
    document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  }, []);

  const downloadImage = async () => {
    if (!myData || myData.length === 0) {
      toast.info("Please select account before download");
      return;
    }

    const node = domEl.current;
    if (!node) {
      toast.error("Export target not found");
      return;
    }

    // Calculate bounding box size
    const rect = node.getBoundingClientRect();
    const width = Math.ceil(rect.width);
    const height = Math.ceil(rect.height);

    try {
      const dataUrl = await htmlToImage.toPng(node, {
        width,
        height,
        style: {
          width: `${width}px`,
          height: `${height}px`,
          transform: "none",
          overflow: "visible",
        },
        cacheBust: true,
        backgroundColor: "white",
      });

      const link = document.createElement("a");
      link.download = `${optiononenew}-${defaultOption}-${JSON.parse(
        localStorage.getItem("MCData"),
      )?.selectedDistrict?.toString()}.png`;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Image export failed:", error);
      toast.error("Could not download image");
    }
  };
  const onchanges = (value, dateString) => {
    setParameterthree(dateString);
  };
  const onRedirection = (event) => {
    navigate(-1);
  };

  const add = (param, paramex, code, name, index, colour) => (e) => {
    console.log("callneethu", param, paramex, code, name, index, colour);
    let Obj = {
      code: code,
      meters: param,
    };

    myAggregate.push(Obj);

    let organizedData = {};
    myAggregate.forEach((obj) => {
      if (!organizedData[obj.code]) {
        organizedData[obj.code] = { code: obj.code, meters: [] };
      }

      // Convert the values to strings before pushing to ensure consistency
      const metersArray = Array.isArray(obj.meters)
        ? obj.meters.map((meter) => String(meter))
        : [String(obj.meters)];

      organizedData[obj.code].meters.push(...metersArray);
    });

    let resultArray = Object.values(organizedData);
    setmyAggregate(resultArray);
    if (mySample?.includes(param)) {
      var array = [...mySample];
      var index = array.indexOf(param);
      if (index !== -1) {
        array.splice(index, 1);

        setmySample(array);
      }
    } else {
      if (myDatas.length < 8) {
        setmySample([...mySample, param]);
        console.log("llllllllll", mySample);
      }
    }
    if (myData?.includes(paramex)) {
      setMessagecount(messagecount - 1);
      var array = [...myData];
      var newarray = [...myDatas];
      var index = array.indexOf(paramex);
      var inexnew = newarray.indexOf(paramex);
      setCount(count - 1);
      if (index !== -1) {
        array.splice(index, 1);
        newarray.splice(index, 1);
        setmyData(array);
        setmyDatas(newarray);
        setTest(newarray);
      }
    } else {
      if (myDatas.length < 8) {
        setMessagecount(messagecount + 1);
        const items = myData;

        const item = myDatas;
        let meter = paramex;
        const colours = colour;
        const arrays = { colours, meter, code, name };
        myDatas.push(arrays);
        setmyData([...items, paramex]);
        console.log("myData", myData);
        console.log("myDatas", myDatas);
        setTest(myDatas);
        setCount(count + 1);
      } else {
        toast.info("Only 8 Meters can be selected at a time");
      }
    }
  };
  const handleToggleChange = () => {
    setIsChecked(!isChecked);
  };
  const onselectClicks = () => {
    // setName('Accountability');
    setWater(true);
    setWateragg(false);
    navigate("/Waters");
  };
  const onselectClickss = () => {
    // setName('Accountability');
    setWater(false);
    setWateragg(true);
    navigate("/Wateragg");
  };
  const onChangeToWaterMeterReading = () => {
    navigate("/watermeterreadings");
  };
  // const onchange = (value, dateString) => {
  //   setParameterone(dateString[0]);
  //   setParametertwo(dateString[1]);
  //   var diff =
  //     (new Date(parametertwo) - new Date(parameterone)) /
  //     (1000 * 60 * 60 * 24) /
  //     7 /
  //     2;
  //   var diffs = new Date(parametertwo) - new Date(parameterone);

  //   console.log(diffs, "Different Days");

  //   setvalue(
  //     Math.floor(
  //       (new Date(parametertwo) - new Date(parameterone)) /
  //         (1000 * 60 * 60 * 24) /
  //         7
  //     )
  //   );
  //   //  console.log("days", diffs/(24 *60 * 60 *1000));
  //   setSlmax(diff);
  // };

  const onchange = (value, dateString) => {
    const start = dateString[0];
    const end = dateString[1];

    setParameterone(start);
    setParametertwo(end);

    const diffDays = (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);

    // Set the interval automatically
    if (defaultOption === "Custom") {
      if (diffDays > 7) {
        setOptiononenew("Week"); // Auto-select Week
      } else {
        setOptiononenew("Day"); // Below a week → default to Days
      }
    }

    setvalue(Math.floor(diffDays / 7));
    setSlmax(diffDays / 14);
  };

  const onSelects = (event) => {
    if (event == "account") setDefaultOptionss("Account");
    else if (event == "category") setDefaultOptionss("Category");
  };
  const onSelectCategory = (event) => {
    setDefaultCategory(event);
  };
  const sliderChange = (event) => {
    setSlvalue(event.target.value);
  };
  const onMouseClick = (event) => {
    setSlvalue(1);
    setDefaultOption(event.target.value);
    if (event.target.value == "Past Day") {
      setOptiononenew("Hour");
    } else if (
      event.target.value == "Past Year" ||
      event.target.value == "Past Month" ||
      event.target.value == "Past 3 Months" ||
      event.target.value == "Custom"
    ) {
      setOptiononenew("Day");
    } else if (event.target.value == "Past Week") {
      setOptiononenew("Day");
    }
  };
  const radioChanges = (event) => {
    setOptionone(event.target.id);
  };
  const radioChange = (event) => {
    event.stopPropagation();
    setSlvalue(1);
    setOptiononenew(event.target.id);
  };
  const items = [
    {
      label: (
        <a href="#" onClick={downloadImage}>
          Download As PNG
        </a>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <button className="csvlink">
          <CSVLink
            data={listOfUsers}
            filename={
              optiononenew.toString() +
              "-" +
              defaultOption.toString() +
              "-" +
              JSON.parse(
                localStorage.getItem("MCData"),
              )?.selectedDistrict?.toString()
            }
          >
            Download As CSV
          </CSVLink>
        </button>
      ),

      key: "1",
    },
  ];
  const dailyClick = () => {
    setToggle(false);
  };
  const hourlyClick = () => {
    setToggle(true);
  };

  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/user_color?user_id=${userid}`).then((response) => {
      console.log(response.data.color);
      setColor(response.data.color);
    });
  }, []);
  useEffect(() => {
    let arryDatas = [];

    if (
      defaultOption !== "Custom" &&
      myData.length > 0 &&
      myDatas.length < 9 &&
      isChecked
    ) {
      setLoading(true);

      const params = myAggregate.map((item) => ({ ...item }));

      post(
        `apis/water/aggregate?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}`,
        params,
      )
        .then((response) => {
          console.log("aggregateresponse", response.data.data.water_flow);
          const aggregatedData = response?.data?.data?.water_flow;

          aggregatedData.forEach((flowData) => {
            flowData.data.forEach((x) => {
              let Obj = {
                name: x.option,
                [flowData.code]: x.flow,
                code: flowData.code,
              };
              arryDatas.push(Obj);
            });
          });

          console.log("kkkk", arryDatas);
          const groupedData = {};

          // Group objects by "code"
          arryDatas.forEach((obj) => {
            const { code } = obj;

            if (!groupedData[code]) {
              groupedData[code] = [];
            }

            groupedData[code].push(obj);
          });

          // Convert the object back to an array
          const resultArray = Object.values(groupedData);

          console.log("ddddddd", resultArray);
          setAggregateData(resultArray);
          setLoading(false); // Assuming you want to stop the loading state after fetching data.
        })
        .catch((error) => {
          setAggregateData(null);
          setLoading(false); // Also stop loading on error.
        });
    }
  }, [
    mySample,
    optiononenew,
    slvalue,
    defaultOption,
    isChecked,
    selectedDistrict,
  ]);

  useEffect(() => {}, [toggle, selectedDistrict]);

  useEffect(() => {
    console.log("Water Meter Test!!");

    const controller = new AbortController();
    const signal = controller.signal;

    // Determine which sample and data count to use
    const sampleSet = defaultOption === "Custom" ? initialSample : mySample;
    const dataSetLength =
      defaultOption === "Custom" ? myDatas.length : myData.length;

    // Exit early if not within bounds
    if (dataSetLength === 0 || dataSetLength >= 9) return;

    const fetchWaterFlowData = async () => {
      try {
        setLoading(true);

        // Prevent API call if custom range but start/end are missing
        if (defaultOption === "Custom" && (!parameterone || !parametertwo)) {
          console.warn("Skipping fetch: start or end date is missing");
          setLoading(false);
          return;
        }
        let url = `apis/water/new?option=${optiononenew}&range_option=${defaultOption}&interval=${slvalue}&meterid=${JSON.stringify(
          mySample,
        )}`;

        if (defaultOption === "Custom") {
          url += `&start=${parameterone}&end=${parametertwo}`;
        }

        const res = await get(url, { signal });

        const flowData = res?.data?.data?.water_flow || [];
        setListofUsers(res?.data?.data?.download_water_flow);

        const merged = flowData.map((item) => {
          const first = item[0] || {};
          const meterData = Object.fromEntries(
            item.map(({ unique_name, flow }) => [unique_name, flow]),
          );
          return {
            name: first.flow_date_check || "",
            names: first.option || "",
            month: first.option_month || "",
            ...meterData,
          };
        });

        setMerge(merged); // Only one clean call
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Water data fetch error:", err);
        } else {
          console.log("successfully aborted");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchWaterFlowData();

    return () => {
      controller.abort();
    };
  }, [
    myData.length,
    myDatas.length,
    mySample,
    initialSample,
    optiononenew,
    slvalue,
    defaultOption,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchHourlyAverage = async () => {
      try {
        if (
          defaultOption === "Custom" &&
          parameterone !== undefined &&
          parametertwo !== undefined &&
          myDatas.length < 9
        ) {
          setLoadings(true);

          if (!parameterone || !parametertwo) {
            return;
          }
          const res = await get(
            `apis/hourly_average?option_one=${optionone}&option=${defaultOption}&option_two=Weekday&start_date=${parameterone}&end_date=${parametertwo}&selected=${JSON.stringify(
              mySample,
            )}`,
            { signal },
          );

          res.data.data.hourly_avg.option_one.forEach((item) => {
            const name = item[0]?.name;
            const meterData = Object.fromEntries(
              item?.map(({ avg, meter_id }) => [meter_id, avg]),
            );
            const weeklyMeterData = { name, ...meterData };
            arryDatass.push(weeklyMeterData);
          });

          setTimeout(() => {
            setNerge(arryDatass);
          }, 1000);

          setLoadings(false);
        } else if (myData.length > 0 && myDatas.length < 9) {
          setLoadings(true);
          if (!defaultOption) {
            return;
          }
          const res = await get(
            `apis/hourly_average?option_one=${optionone}&option=${defaultOption}&option_two=Weekday&selected=${JSON.stringify(
              mySample,
            )}`,
            { signal },
          );

          console.log("default loaded data7");

          res.data.data.hourly_avg.option_one.forEach((item) => {
            const name = item[0]?.name;
            const meterData = Object.fromEntries(
              item?.map(({ avg, meter_id }) => [meter_id, avg]),
            );
            const weeklyMeterData = { name, ...meterData };
            arryDatass.push(weeklyMeterData);
            console.log("arryDatass default load ::", arryDatass);
          });

          setTimeout(() => {
            setNerge(arryDatass);
          }, 1000);

          setLoadings(false);
        }
      } catch (err) {
        // if (err.name === "AbortError") {
        //     console.log("successfully aborted");
        // } else {
        //     console.error("Error fetching hourly average:", err);
        // }
        errorHandler(err); // centralized
        throw err; // re-throw so calling code (like useEffect) can still handle it
      }
    };

    fetchHourlyAverage();

    return () => {
      controller.abort();
    };
  }, [
    myData,
    optionone,
    defaultOption,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);

  useEffect(() => {
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined &&
      myDatas.length < 9
    ) {
      setLoadings(true);
      if (!parameterone || !parametertwo) {
        return;
      }
      get(
        `apis/daily_average?&option=${defaultOption}&start_date=${parameterone}&end_date=${parametertwo}&selected=${JSON.stringify(
          mySample,
        )}`,
        {
          signal: signal,
        },
      )
        .then((res) => {
          res.data.data.daily_avg_data.daily_avg.map((item) => {
            let name = item?.option_name;
            const meterData = Object.fromEntries(
              item?.value.map(({ meter_id, avg }) => [meter_id, avg]),
            );

            const weeklyMeterData = { name, ...meterData };

            arryDatassnew.push(weeklyMeterData);

            setTimeout(() => {
              setMergenew(arryDatassnew);
            }, 1000);

            console.log(mergenew);
          });
          setLoadings(false);
        })
        .catch((err) => {
          if (err.name === "AbortError") {
            console.log("successfully aborted");
          }
        });
      return () => {
        controller.abort();
      };
    }
    // else {
    //     if (myData.length > 0 && myDatas.length < 9) {
    // --- NON-CUSTOM option ---
    if (defaultOption !== "Custom" && myData.length > 0 && myDatas.length < 9) {
      setLoadings(true);
      get(
        `apis/daily_average?&option=${defaultOption}&selected=${JSON.stringify(
          mySample,
        )}`,
        {
          signal: signal,
        },
      )
        .then((res) => {
          res.data.data.daily_avg_data.daily_avg.map((item) => {
            let name = item?.option_name;
            const meterData = Object.fromEntries(
              item?.value.map(({ meter_id, avg }) => [meter_id, avg]),
            );

            const weeklyMeterData = { name, ...meterData };

            arryDatassnew.push(weeklyMeterData);

            setTimeout(() => {
              setMergenew(arryDatassnew);
            }, 1000);

            console.log("mergenew", mergenew);
          });
          setLoadings(false);
        })
        .catch((err) => {
          if (err.name === "AbortError") {
            console.log("successfully aborted");
          }
        });
      return () => {
        controller.abort();
      };
      // }
    }
  }, [myData, defaultOption, parameterone, parametertwo, selectedDistrict]);

  const handleCallback = (childData, res) => {
    console.log("res", res);
    setcallData(childData.data.data.meters.selected_meters);
    console.log("calldata", childData.data.data.meters.selected_meters);
    const products = [];
    const productmysample = [];
    {
      childData.data.data.meters.selected_meters.map((person) => {
        return (
          <div>
            {person.meters.map((persons, index) => {
              products.push(persons.meter_unique_name);
              productmysample.push(persons.unique_name);
            })}
          </div>
        );
      });
    }
    setResponse(res);
    if (response.length > 0) {
      console.log("sss feww --", myData);
      var ress = myData.filter((item) => products.includes(item));
      setmyData(ress);
      var resmysample = mySample.filter((item) =>
        productmysample.includes(item),
      );
      setmySample(resmysample);
      var ressult = myDatas.filter((item) => products.includes(item.meter));
      setmyDatas(ressult);
      setTest(myDatas);
      console.log("sss neethu --", ressult);
      console.log(test, test);
    }
    if (childData.data.data.meters.selected_meters.length == 0) {
      setmyData([]);
      setNerge([]);
      setTest([]);
      setMerge([]);
      setmyDatas([]);
      setMergenew([]);
      setmySample([]);
    }
  };

  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="waterDetails">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onRedirection}
              />
              {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
              {/* <h3 className="mb-0">Water Usage</h3> */}
              <div className="d-flex align-items-center">
                <div
                  className="new-box-padding  text-blue  align-self-center c-pointer "
                  onClick={onselectClicks}
                  style={{
                    borderBottom: "2px solid #1998f0",
                    borderRadius: "0",
                  }}
                >
                <span className="d-inline-flex align-items-center gap-1">
                  Water Usage{" "}
                  <tooltip title="Shows water consumption per meter for the selected date range. Compare usage of up to 8 meters at once.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                  </span>
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  onClick={onselectClickss}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                <span className="d-inline-flex align-items-center gap-1">
                  Aggregate Usage
                  <tooltip title="Shows total water consumption per account for the selected date range. Use the category toggle to view usage by meter category within each account.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                  </span>
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  onClick={onChangeToWaterMeterReading}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                <span className="d-inline-flex align-items-center gap-1">
                  Meters By Flow
                  <tooltip title="Lists meters in descending order of total flow for the selected date range and preselected meter categories. View water consumption trends over the selected period.">
                    <InfoCircleOutlined
                      className="ms-1 text-blue"
                      style={{ fontSize: "14px" }}
                    />
                  </tooltip>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="row m-0 row-cols-4 g-3 align-items-center w-100 mt-2">
            <div className="col-12 col-lg-3 ps-0">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h3
                  className="my-0"
                  style={{
                    margin: "0rem",
                    padding: "0.25rem 0.5em",
                    fontSize: "fs-26",
                    color: "#1998f0",
                    height: "50px",
                  }}
                >
                  {" "}
                  Accounts{" "}
                </h3>
              </div>
            </div>

            <div className="col-12 col-lg-3 mt-0 multiselectDropdownStyle">
              <div className="w-100 text-blue">Accounts</div>
              <ExampleWithDistrict
                parentCallback={handleCallback}
                elementValue={myData}
                key={selectedDistrict?.selectedDistrict}
                selectedDistrict={selectedDistrict?.selectedDistrict}
              />
            </div>

            <div className="col-12 col-lg-3 mt-0">
              <div className="w-100 text-blue">Date Range</div>
              <div
                id="1st"
                className="w-100 d-flex selectCalender ms-auto mt-0 water-space align-items-center
                            justify-content-center"
              >
                <div className="d-flex w-100">
                  <div className="fs-26 fw-bold d-flex w-100 water">
                    <select
                      name="All meters"
                      id="selector"
                      className="box"
                      onChange={onMouseClick}
                    >
                      <option value="Past Year">Past 365 Days</option>
                      <option value="Past 3 Months">Past 90 Days </option>
                      <option value="Past Month" selected>
                        Past 30 Days
                      </option>
                      <option value="Past Week">Past 7 Days</option>
                      <option value="Past Day">Past Day</option>
                      <option value="Custom">Custom</option>
                    </select>
                  </div>
                  <Space
                    direction="horizontal"
                    size={1}
                    className="custom-date"
                  >
                    {defaultOption === "Custom" ? (
                      <RangePicker
                        onChange={onchange}
                        disabledDate={disabledDate}
                        separator={<SwapOutlined />}
                      />
                    ) : (
                      ""
                    )}
                  </Space>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-2 mt-0">
              <div className="w-100 text-blue">Interval</div>
              <div className="dropdown intervaldropdown">
                <button
                  className="btn w-100 text-left-content d-flex justify-content-between align-items-center"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {optiononenew === "Months"
                    ? optiononenew
                    : slvalue + " " + optiononenew}
                  <span className="d-block" style={{ lineHeight: "0" }}>
                    {" "}
                    <CaretDownOutlined />{" "}
                  </span>
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li className="interdrop">
                    {" "}
                    {defaultOption == "Past Week" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Day"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Day"
                            onClick={radioChange}
                          >
                            Days
                          </label>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOption == "Past Day" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Hour"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Hour"
                            onClick={radioChange}
                          >
                            Hours
                          </label>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOption == "Past 3 Months" ||
                    defaultOption == "Past Month" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Day"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Day"
                            onClick={radioChange}
                          >
                            Days
                          </label>
                        </div>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Week"
                            onClick={radioChange}
                            checked={optiononenew === "Week"}
                          />
                          <label
                            className="form-check-label"
                            for="Week"
                            onClick={radioChange}
                          >
                            Weeks
                          </label>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOption === "Past Year" ||
                    defaultOption == "Custom" ? (
                      <>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Day"
                            onClick={radioChange}
                            defaultChecked="true"
                          />
                          <label
                            className="form-check-label"
                            for="Day"
                            onClick={radioChange}
                          >
                            Days
                          </label>
                        </div>
                        <div class="form-check d-flex align-items-center">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="Week"
                            onClick={radioChange}
                          />
                          <label
                            className="form-check-label"
                            for="Week"
                            onClick={radioChange}
                          >
                            Weeks
                          </label>
                        </div>
                        {defaultOption === "Past Year" ||
                        (defaultOption === "Custom" &&
                          (new Date(parametertwo) - new Date(parameterone)) /
                            (1000 * 60 * 60 * 24) >
                            179) ? (
                          <div class="form-check d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="Months"
                              onClick={radioChange}
                              defaultChecked="true"
                              checked={optiononenew === "Months"}
                            />
                            <label
                              className="form-check-label"
                              for="Months"
                              onClick={radioChange}
                            >
                              Months
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </li>

                  {optiononenew !== "Months" ? (
                    <li
                      className="interdrop"
                      style={{ borderTop: "1px solid #ccc" }}
                    >
                      <div className="d-flex w-100 align-items-center mt-2 justify-content-between">
                        <label className="me-4">Range</label>
                        <div className="fs-26 fw-bold d-flex w-50 water">
                          {optiononenew === "Week" ? (
                            <select
                              name="All meters"
                              id="selector"
                              className="box"
                              onChange={sliderChange}
                              style={{ border: "1px solid #ccc" }}
                            >
                              <option value="1" selected>
                                1
                              </option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          ) : (
                            <select
                              name="All meters"
                              id="selector"
                              className="box"
                              onChange={sliderChange}
                              style={{ border: "1px solid #ccc" }}
                            >
                              <option value="1" selected>
                                1
                              </option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                            </select>
                          )}
                        </div>
                      </div>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>

            <div className="col-12 col-lg-1 mt-0 p-0">
              <div className="ml-auto downloads float-right mt-4">
                <Dropdown
                  getPopupContainer={(trigger) => trigger.parentNode}
                  menu={{
                    items,
                  }}
                  trigger={["click"]}
                  className="me-0 px-3"
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space>
                      <img
                        src={download}
                        alt="download"
                        style={{ width: "25px" }}
                        title="Download"
                      />
                    </Space>
                  </a>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>

        <div className="row me-0 pt-4">
          <div className="col-12 col-lg-3 water-100">
            <div className="water-accountList rounded pt-2">
              {callData?.map((person, indexs) => (
                <div key={indexs}>
                  <ul className="ps-0">
                    <h5 className="py-2">{person.Overide_acc_name}</h5>
                    {person.meters.map((meter, index) => (
                      <>
                        <li
                          className="d-flex align-items-center gap-3"
                          onClick={add(
                            meter.unique_name,
                            meter.meter_unique_name,
                            meter.code,
                            meter.overided_name.substring(0, 12),
                            index,
                            color[meter.count % color.length],
                          )}
                        >
                          {myData?.includes(meter.meter_unique_name) ? (
                            <div>
                              <DashboardOutlined
                                className="dashboardIcon"
                                style={{
                                  color:
                                    color[
                                      myData.indexOf(meter.meter_unique_name)
                                    ],
                                }}
                              />
                            </div>
                          ) : (
                            <div>
                              <DashboardOutlined className="dashboardIcon icon-color" />
                            </div>
                          )}
                          <div className="water-enterprises responsive-water">
                            <div className="water-sidemenu">
                              <h5 className="mb-0"> {meter.name}</h5>{" "}
                              <span>
                                <div
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <p>{meter.meter_id}</p>
                                  {meter.register_number ? (
                                    <p>({meter.register_number})</p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </span>
                            </div>
                            <div>Date Range: {meter.date_range}</div>
                          </div>
                        </li>{" "}
                        <hr />
                      </>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          {isChecked ? (
            <div
              className="col-12 col-lg-9 water-chartList"
              id="domEl"
              ref={domEl}
            >
              <div className="bg-white pt-4 mt-4">
                <div
                  style={{
                    maxWidth: "100%",
                    margin: "0 auto",
                    height: "500px",
                  }}
                  className="line-chart"
                >
                  <ResponsiveContainer>
                    <LineChart
                      data={aggregateData[0] ?? []}
                      margin={{
                        top: 5,
                        right: 50,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      {aggregateData[0]?.length > 0 && (
                        <>
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey={aggregateData[0][0]?.code}
                            key="pdLine"
                            stroke={color[0]}
                            activeDot={{ r: 8 }}
                            fill={color[0]}
                            strokeWidth={3}
                          />
                          <CartesianGrid stroke="lightGrey" />
                          <Tooltip />
                        </>
                      )}
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                <div
                  style={{
                    maxWidth: "100%",
                    margin: "0 auto",
                    height: "500px",
                  }}
                  className="line-chart"
                >
                  <ResponsiveContainer>
                    <LineChart
                      data={aggregateData[1] ?? []}
                      margin={{
                        top: 5,
                        right: 50,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      {aggregateData[1]?.length > 0 && (
                        <>
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey={aggregateData[1][0]?.code}
                            key="pdLine"
                            stroke={color[1]}
                            activeDot={{ r: 8 }}
                            fill={color[1]}
                            strokeWidth={3}
                          />
                          <CartesianGrid stroke="lightGrey" />
                          <Tooltip />
                        </>
                      )}
                    </LineChart>
                  </ResponsiveContainer>
                </div>
                <div
                  style={{
                    maxWidth: "100%",
                    margin: "0 auto",
                    height: "500px",
                  }}
                  className="line-chart"
                >
                  <ResponsiveContainer>
                    <LineChart
                      data={aggregateData[2] ?? []}
                      margin={{
                        top: 5,
                        right: 50,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      {aggregateData[2]?.length > 0 && (
                        <>
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey={aggregateData[2][0]?.code}
                            key="pdLine"
                            stroke={color[2]}
                            activeDot={{ r: 8 }}
                            fill={color[2]}
                            strokeWidth={3}
                          />
                          <CartesianGrid stroke="lightGrey" />
                          <Tooltip />
                        </>
                      )}
                    </LineChart>
                  </ResponsiveContainer>
                </div>
                <div
                  style={{
                    maxWidth: "100%",
                    margin: "0 auto",
                    height: "500px",
                  }}
                  className="line-chart"
                >
                  <ResponsiveContainer>
                    <LineChart
                      data={aggregateData[3] ?? []}
                      margin={{
                        top: 5,
                        right: 50,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      {aggregateData[3]?.length > 0 && (
                        <>
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey={aggregateData[3][0]?.code}
                            key="pdLine"
                            stroke={color[3]}
                            activeDot={{ r: 8 }}
                            fill={color[3]}
                            strokeWidth={3}
                          />
                          <CartesianGrid stroke="lightGrey" />
                          <Tooltip />
                        </>
                      )}
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div
                className="col-12 col-lg-9 water-chartList"
                id="domEl"
                ref={domEl}
              >
                <div className="bg-white pt-4 mt-4">
                  {loading === false ? (
                    <>
                      <div
                        style={{
                          maxWidth: "100%",
                          margin: "0 auto",
                          height: "500px",
                          position: "relative",
                        }}
                        className="water-graph "
                      >
                        <ResponsiveContainer>
                          <LineChart
                            style={{ height: "469px" }}
                            data={merge}
                            margin={{
                              top: 5,
                              right: 10,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <XAxis
                              xAxisId="0"
                              dataKey="name"
                              tick={false}
                              angle={-45}
                              textAnchor="end"
                            />
                            {defaultOption === "Past Year" || value > 10 ? (
                              ""
                            ) : (
                              <XAxis
                                dataKey="names"
                                allowDuplicatedCategory={false}
                                xAxisId="1"
                              />
                            )}
                            <XAxis
                              dataKey="month"
                              allowDuplicatedCategory={false}
                              xAxisId="2"
                            />

                            <YAxis
                              type="number"
                              tickFormatter={(value) => value.toLocaleString()}
                            >
                              <Label
                                value="Gallons"
                                position="insideLeft"
                                angle={-90}
                                style={{
                                  textAnchor: "middle",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                }}
                              />
                            </YAxis>

                            {myDatas?.map((item, index) => (
                              <Line
                                type="monotone"
                                dataKey={item.meter}
                                isAnimationActive={false}
                                name={item?.meter}
                                fill={color[index]}
                                stroke={color[index]}
                                strokeWidth={2}
                              ></Line>
                            ))}
                            <CartesianGrid stroke="lightGrey" />
                            <Tooltip
                              formatter={(value) => value.toLocaleString()}
                            />
                          </LineChart>
                        </ResponsiveContainer>

                        <div className="px-5 d-flex flex-wrap justify-content-start align-items-center mb-1 float-left-new w-100">
                          {myDatas?.map((item, index) => (
                            <>
                              <div className="d-flex me-1 mb-2">
                                <div
                                  style={{
                                    width: 10,
                                    height: 10,
                                    backgroundColor: color[index],
                                    marginRight: 6,
                                  }}
                                ></div>
                                {/* <span className="meter-content"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span></div> */}
                                <span className="meter-content">
                                  <font color={color[index]}>
                                    {item.meter}-{item.name}
                                  </font>
                                </span>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="example">
                      <Spin size="large" />
                    </div>
                  )}
                  <div className="w-100 p-4 float-left-new">
                    <div className="d-flex gap-3 fs-20 fw-bold mb-4">
                      {toggle === true ? (
                        <div
                          className="px-3 py-1 text-black bg-white border rounded d-flex align-items-center justify-content-center c-pointer click-arrow waterbox"
                          style={{ minWidth: "230px" }}
                          onClick={dailyClick}
                        >
                          <ReconciliationOutlined className="pe-2" />
                          Daily Average
                        </div>
                      ) : (
                        <div
                          className="px-3 py-1 text-blue bg-white border border-info rounded d-flex align-items-center justify-content-center c-pointer click-arrow waterbox"
                          style={{ minWidth: "230px" }}
                          onClick={dailyClick}
                        >
                          <ReconciliationOutlined className="pe-2" />
                          Daily Average
                        </div>
                      )}
                      {toggle === false ? (
                        <div
                          className="px-3 py-1 text-black bg-white border rounded d-flex align-items-center justify-content-center c-pointer click-arrow waterboxs"
                          style={{ minWidth: "230px" }}
                          onClick={hourlyClick}
                        >
                          {" "}
                          <FieldTimeOutlined className="pe-2" /> Hourly Average
                        </div>
                      ) : (
                        <div
                          className="px-3 py-1 bg-white text-blue border rounded border-info d-flex align-items-center justify-content-center c-pointer click-arrow waterboxs"
                          style={{ minWidth: "230px" }}
                          onClick={hourlyClick}
                        >
                          {" "}
                          <FieldTimeOutlined className="pe-2" /> Hourly Average
                        </div>
                      )}
                    </div>

                    <div className="d-flex align-items-start">
                      {toggle === true ? (
                        <div className="days-waters">
                          <div class="form-check d-flex mb-2 align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Weekday"
                              name="day"
                              onChange={radioChanges}
                              defaultChecked={true}
                            />
                            <label className="form-check-label" for="day1">
                              Weekdays
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Weekend"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day2">
                              Weekends
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Sundays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day3">
                              Sunday
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Mondays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day4">
                              Monday
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Tuesdays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day5">
                              Tuesday
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Wednesdays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day6">
                              Wednesday
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Thursdays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day7">
                              Thursday
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Fridays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day8">
                              Fridays
                            </label>
                          </div>
                          <div className="form-check mb-2 d-flex align-items-center">
                            <Input
                              className="form-check-input"
                              type="radio"
                              id="Saturdays"
                              name="day"
                              onChange={radioChanges}
                            />
                            <label className="form-check-label" for="day9">
                              Saturday
                            </label>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {loadings === false ? (
                        <>
                          {toggle === true ? (
                            <div
                              style={{
                                maxWidth: "100%",
                                margin: "0 auto",
                                minHeight: "350px",
                              }}
                              className="legend-wrapper position-relative scroll-show"
                            >
                              <ResponsiveContainer>
                                <>
                                  <LineChart
                                    data={nerge}
                                    width={1050}
                                    height={300}
                                    margin={{
                                      top: 5,
                                      right: 30,
                                      left: 20,
                                      bottom: 1,
                                    }}
                                  >
                                    <XAxis
                                      dataKey="name"
                                      interval={0}
                                      angle={30}
                                      dx={20}
                                    />
                                    <YAxis
                                      tickFormatter={(value) =>
                                        value.toLocaleString()
                                      }
                                    />

                                    <div className="px-5 d-flex flex-wrap justify-content-start align-items-center">
                                      {myDatas?.map((item, index) => (
                                        <>
                                          <div className="d-flex me-1 mb-2">
                                            <div
                                              style={{
                                                width: 10,
                                                height: 10,
                                                backgroundColor: color[index],
                                                marginRight: 6,
                                              }}
                                            ></div>
                                            {/* <span className="meter-content"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span></div> */}
                                            <span className="meter-content">
                                              <font color={color[index]}>
                                                {item.meter}-{item.name}
                                              </font>
                                            </span>
                                          </div>
                                        </>
                                      ))}
                                    </div>

                                    {myDatas?.map((item, index) => (
                                      <Line
                                        type="monotone"
                                        dataKey={item.meter}
                                        isAnimationActive={false}
                                        name={item?.meter}
                                        fill={color[index]}
                                        stroke={color[index]}
                                        strokeWidth={2}
                                      ></Line>
                                    ))}
                                    <CartesianGrid stroke="lightGrey" />
                                    <Tooltip
                                      formatter={(value) =>
                                        value.toLocaleString()
                                      }
                                    />
                                  </LineChart>

                                  <div className="labelYAxis2">Gallons </div>
                                  <div className="px-2 d-flex flex-wrap justify-content-start align-items-center">
                                    {myDatas?.map((item, index) => (
                                      <>
                                        <div className="d-flex me-1 mb-2">
                                          <div
                                            style={{
                                              width: 10,
                                              height: 10,
                                              backgroundColor: color[index],
                                              marginRight: 6,
                                            }}
                                          ></div>
                                          {/* <span className="meter-contents"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span></div> */}
                                          <span className="meter-contents">
                                            <font color={color[index]}>
                                              {item.meter}-{item.name}
                                            </font>
                                          </span>
                                        </div>
                                      </>
                                    ))}
                                  </div>
                                </>
                              </ResponsiveContainer>
                            </div>
                          ) : (
                            <div
                              style={{
                                maxWidth: "100%",
                                margin: "0 auto",
                                position: "relative",
                              }}
                              className="scroll-show legend-wrapper"
                            >
                              <BarChart
                                id="canvas"
                                width={1200}
                                height={300}
                                margin={{
                                  top: 5,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                                }}
                                data={mergenew}
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                  dataKey="name"
                                  interval={0}
                                  angle={0}
                                  dx={20}
                                />
                                <YAxis
                                  tickFormatter={(value) =>
                                    value.toLocaleString()
                                  }
                                />
                                <Tooltip
                                  formatter={(value) => value.toLocaleString()}
                                />
                                {myDatas?.map((item, index) => (
                                  <Bar
                                    dataKey={item?.meter}
                                    fill={color[index]}
                                  />
                                ))}
                              </BarChart>

                              <div className="labelYAxis4">Gallons</div>
                              <div className="px-5 d-flex flex-wrap justify-content-start align-items-center">
                                {myDatas?.map((item, index) => (
                                  <>
                                    <div className="d-flex me-1 mb-2">
                                      <div
                                        style={{
                                          width: 10,
                                          height: 10,
                                          backgroundColor: color[index],
                                          marginRight: 6,
                                        }}
                                      ></div>
                                      {/* <span className="meter-content"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span></div> */}
                                      <span className="meter-content">
                                        <font color={color[index]}>
                                          {item.meter}-{item.name}
                                        </font>
                                      </span>
                                    </div>
                                  </>
                                ))}
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="examples">
                          <Spin size="large" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Main>
    </>
  );
}

export default Waters;
